import React from "react";
import { translate } from "../../../../../../common/providers";
import DocumentSelector from "../document-selector/DocumentSelector";
import TerritorySelector from "../territory-selector/TerritorySelector";
import EmailTagInput from "../email-tag-input/EmailTagInput";
import styles from "./NotificationForm.module.css";
import { generateSubject } from "../../../../utils/utils";
import { CustomTextField } from "../../../../../../common/components";

export default function NotificationForm({ formData, projectId, projectName, onFormChange, defaultTerritoryId }) {
	return (
		<div className={styles.form}>
			<div className={styles.formContainer}>
				<div className={styles.field}>
					<DocumentSelector
						projectId={projectId}
						selectedDocuments={formData.documents}
						onChange={(docs) => onFormChange("documents", docs)}
					/>
				</div>

				<div className={styles.field}>
					<TerritorySelector
						defaultTerritoryId={defaultTerritoryId}
						projectId={projectId}
						selectedTerritories={formData.territories}
						onChange={(territories) => onFormChange("territories", territories)}
					/>
				</div>

				<div className={styles.field}>
					<EmailTagInput
						emails={formData.recipientEmails}
						onChange={(emails) => onFormChange("recipientEmails", emails)}
					/>
				</div>

				<div className={styles.field}>
					<label className={styles.label} htmlFor="notification-subject-additional">
						{translate("document-center.distribution-notification.subject.label")}
						<span className={styles.required}>*</span>
					</label>
					<CustomTextField
						disabled
						fullWidth
						multiline
						size="small"
						sx={{
							"& .MuiOutlinedInput-root": {
								backgroundColor: "var(--grey-50)",
								"& .MuiOutlinedInput-notchedOutline": {
									borderColor: "#E0E0E0",
								},
							},
							"& .MuiInputBase-input.Mui-disabled": {
								WebkitTextFillColor: "#333333",
								cursor: "default",
							},
						}}
						value={generateSubject(projectName, formData.additionalSubject)}
						variant="outlined"
					/>
					<CustomTextField
						fullWidth
						id="notification-subject-additional"
						placeholder={translate(
							"document-center.distribution-notification.subject.additional.placeholder"
						)}
						size="small"
						value={formData.additionalSubject}
						variant="outlined"
						onChange={(e) => onFormChange("additionalSubject", e.target.value)}
					/>
				</div>

				<div className={styles.field}>
					<label className={styles.label} htmlFor="notification-distribution-type">
						{translate("document-center.distribution-notification.distribution-type.label")}
						<span className={styles.required}>*</span>
					</label>
					<CustomTextField
						fullWidth
						id="notification-distribution-type"
						inputProps={{ maxLength: 80 }}
						placeholder={translate(
							"document-center.distribution-notification.distribution-type.placeholder"
						)}
						size="small"
						value={formData.distributionType}
						variant="outlined"
						onChange={(e) => onFormChange("distributionType", e.target.value)}
					/>
				</div>

				<div className={styles.field}>
					<label className={styles.label} htmlFor="notification-summary">
						{translate("document-center.distribution-notification.summary.label")}
						<span className={styles.required}>*</span>
					</label>
					<CustomTextField
						fullWidth
						multiline
						id="notification-summary"
						inputProps={{ maxLength: 1000 }}
						placeholder={translate("document-center.distribution-notification.summary.placeholder")}
						rows={4}
						value={formData.summary}
						variant="outlined"
						onChange={(e) => onFormChange("summary", e.target.value)}
					/>
				</div>
			</div>
		</div>
	);
}
